import React from 'react';
import {
  Box,
  Flex,
  Text,
  HStack,
  Stack,
  Badge,
  Progress,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Heading,
  Card,
  CardHeader,
  CardBody,
  Spinner,
  useColorModeValue,
} from '@chakra-ui/react';

/**
 * PerformanceMetrics - Component to display different performance metrics in tabs
 * 
 * @param {Object} props - Component props
 * @param {Array} props.performanceData - Data for category performance
 * @param {boolean} props.isLoading - Loading state
 */
const PerformanceMetrics = ({ performanceData, isLoading }) => {
  const cardBg = useColorModeValue('white', 'gray.700');
  
  return (
    <Card bg={cardBg} boxShadow="md">
      <CardHeader pb={0}>
        <Heading size="md">Métricas de Desempenho</Heading>
      </CardHeader>
      <CardBody>
        <Tabs colorScheme="yellow" isFitted>
          <TabList>
            <Tab>Categorias</Tab>
            <Tab>Financeiro</Tab>
            <Tab>Usuários</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              {isLoading ? (
                <Flex justify="center" align="center" h="200px">
                  <Spinner size="xl" color="yellow.500" />
                </Flex>
              ) : (
                <Stack spacing={4} mt={2}>
                  {performanceData.map((item, index) => (
                    <Box key={index}>
                      <Flex justify="space-between" mb={1}>
                        <Text fontWeight="medium">{item.name}</Text>
                        <HStack>
                          <Text fontWeight="bold">{item.value}%</Text>
                          <Badge colorScheme={item.change > 0 ? 'green' : 'red'}>
                            {item.change > 0 ? `+${item.change}%` : `${item.change}%`}
                          </Badge>
                        </HStack>
                      </Flex>
                      <Progress 
                        value={item.value} 
                        colorScheme={item.change > 0 ? 'green' : 'red'} 
                        size="sm" 
                        borderRadius="full" 
                      />
                    </Box>
                  ))}
                </Stack>
              )}
            </TabPanel>
            <TabPanel>
              <Flex justify="center" align="center" h="200px" direction="column">
                <Text color="gray.500" mb={4}>Gráfico de desempenho financeiro</Text>
                <Text fontSize="sm">Nesta visualização seriam exibidos gráficos de receita, lucro, crescimento, etc.</Text>
              </Flex>
            </TabPanel>
            <TabPanel>
              <Flex justify="center" align="center" h="200px" direction="column">
                <Text color="gray.500" mb={4}>Análise de usuários</Text>
                <Text fontSize="sm">Aqui seriam exibidos gráficos de retenção, churn, satisfação, etc.</Text>
              </Flex>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </CardBody>
    </Card>
  );
};

export default PerformanceMetrics;